/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {AuthService} from './auth.service';

export const useAuth = () => {
  const authService = AuthService.getInstance();

  return {
    signIn: authService.signIn.bind(authService),
    signOut: authService.signOut.bind(authService),
    isAuthenticated: authService.isAuthenticated.bind(authService),
    getUserProfile: authService.getUserProfile.bind(authService),
    setUserProfile: authService.setUserProfile.bind(authService),
    getAuthToken: authService.getAuthToken.bind(authService),
    setAuthToken: authService.setAuthToken.bind(authService),
    getGraphqlURL: authService.getGraphqlURL.bind(authService),
    setGraphqlURL: authService.setGraphqlURL.bind(authService),
    getActor: authService.getActor.bind(authService),
    setActor: authService.setActor.bind(authService),
    removeUserProfile: authService.removeUserProfile.bind(authService),
    removeActor: authService.removeActor.bind(authService),
    removeAuthToken: authService.removeAuthToken.bind(authService),
    removeGraphqlURL: authService.removeGraphqlURL.bind(authService),
    getUserName: authService.getUserName.bind(authService),
    getToken: authService.getToken.bind(authService),
    getOrgId: authService.getOrgId.bind(authService),
    setOrgId: authService.setOrgId.bind(authService),
    removeOrgId: authService.removeOrgId.bind(authService),
    getOrganizationId: authService.getOrganizationId.bind(authService)
  };
};
